import { render, staticRenderFns } from "./SellerRiskScore.vue?vue&type=template&id=6ccdff3f&"
import script from "./SellerRiskScore.vue?vue&type=script&lang=js&"
export * from "./SellerRiskScore.vue?vue&type=script&lang=js&"
import style0 from "./SellerRiskScore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SellerRiskScore.vue"
export default component.exports